import { render, staticRenderFns } from "./CreateService.vue?vue&type=template&id=4118e826"
import script from "./CreateService.vue?vue&type=script&lang=ts"
export * from "./CreateService.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports